import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "@/i18n/use-t";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { SerialInput } from "@/components/SerialInput";

export const Route = createFileRoute("/")({
  component: LandingPage,
});

function LandingPage() {
  const { t } = useTranslation("lookup");
  return (
    <Card>
      <CardHeader className="space-y-3">
        <CardTitle className="text-2xl sm:text-3xl">{t("hero.title")}</CardTitle>
        <CardDescription className="text-base">
          {t("hero.subtitle")}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <SerialInput />
      </CardContent>
    </Card>
  );
}
